<template>
  <div class="main-layout">
    <booking-info-box
      v-if="modalRequestComponentName != 'success'"
    ></booking-info-box>
    <div class="container">
      <div class="component-box">
        <transition name="list" appear mode="out-in">
          <component
            v-bind:is="modalRequestComponentName"
            v-on:close="modalClose"
            :propData="modalRequestComponentPropData"
            class="component"
          ></component>
        </transition>
      </div>
      <profile></profile>
    </div>
  </div>
</template>

<script>
import BookingInfoBox from './BookingInfoBox'
import * as types from '../../store/mutation-types'
import { mapGetters } from 'vuex'
import Profile from './Profile'
import MapSelect from './MapSelect'
import Payment from './Payment'
import Success from './Success'

export default {
  name: 'main-layout',
  props: {
    data: {
      default: () => ({}),
      type: [Object, Array]
    }
  },
  data() {
    return {
      serviceDetail: {}
    }
  },
  components: {
    BookingInfoBox,
    Profile,
    mapSelect: MapSelect,
    payment: Payment,
    success: Success
  },
  created() {
    this.$store
      .dispatch(types.SET_MODAL_REQUEST_COMPONENT, { component: 'mapSelect' })
      .then(() => {
        this.$store.dispatch(types.CLEAR_REQUEST_USER_BOOKING, {})
      })
  },
  destroyed() {
    console.log('end')
    this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, { component: '' })
  },
  methods: {
    modalClose() {
      this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
        component: '',
        active: false,
        type: 'full'
      })
    }
  },
  computed: {
    ...mapGetters([
      'modalRequestComponentName',
      'modalRequestComponentPropData'
    ])
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  .booking-info-box {
    margin: 80px 0 0 0;
  }
  /*border: 1px solid red;*/
  margin: 37px auto auto auto;
  width: 1118px;
  height: 100%;
  .container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: auto;

    .component-box {
      overflow-y: auto;
      position: relative;
      /*border: 1px solid red;*/
      width: 812px;
      margin: 36px 20px 60px 0;
    }

    .profile {
      width: 250px;
      /*border: 1px solid red;*/
      margin: 36px 0 0 0;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
